/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailReceiverDto
 */
export interface MailReceiverDto {
    /**
     * 
     * @type {string}
     * @memberof MailReceiverDto
     */
    mailReceiverEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof MailReceiverDto
     */
    mailAddress?: string;
}

export function MailReceiverDtoFromJSON(json: any): MailReceiverDto {
    return MailReceiverDtoFromJSONTyped(json, false);
}

export function MailReceiverDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailReceiverDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mailReceiverEntityId': !exists(json, 'mailReceiverEntityId') ? undefined : json['mailReceiverEntityId'],
        'mailAddress': !exists(json, 'mailAddress') ? undefined : json['mailAddress'],
    };
}

export function MailReceiverDtoToJSON(value?: MailReceiverDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mailReceiverEntityId': value.mailReceiverEntityId,
        'mailAddress': value.mailAddress,
    };
}

